var _defs, _g, _line, _line2, _line3, _line4, _line5, _line6, _line7, _g2, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0, _text1, _text10, _text11, _text12, _text13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBosKoordinat1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.23 131.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #231f20;\n      }\n\n      .cls-4 {\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n        font-size: 5.93px;\n      }\n\n      .cls-2 {\n        stroke-width: .25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.53,
    y1: 120.7,
    x2: 123.7,
    y2: 120.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "127.23 120.7 122.25 122.74 123.43 120.7 122.25 118.67 127.23 120.7"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.58,
    y1: 116.93,
    x2: 22.58,
    y2: 124.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.63,
    y1: 116.93,
    x2: 38.63,
    y2: 124.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.68,
    y1: 116.93,
    x2: 54.68,
    y2: 124.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 70.73,
    y1: 116.93,
    x2: 70.73,
    y2: 124.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 86.78,
    y1: 116.93,
    x2: 86.78,
    y2: 124.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.59,
    y1: 117.02,
    x2: 102.59,
    y2: 124.39
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 118.95,
    y1: 117.02,
    x2: 118.95,
    y2: 124.39
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.57,3.53v117.17c15.05-2.87,34.46-9.27,52.55-23.62,26.15-20.75,36.57-47.83,42.25-62.58,4.2-10.92,6.57-20.39,7.94-27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "6.57 0 4.54 4.97 6.57 3.79 8.6 4.97 6.57 0"
  }))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.48,
    y1: 104.65,
    x2: 8.48,
    y2: 104.65
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.48,
    y1: 88.6,
    x2: 8.48,
    y2: 88.6
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.48,
    y1: 72.55,
    x2: 8.48,
    y2: 72.55
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.48,
    y1: 56.5,
    x2: 8.48,
    y2: 56.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.48,
    y1: 40.45,
    x2: 8.48,
    y2: 40.45
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.57,
    y1: 24.64,
    x2: 8.57,
    y2: 24.64
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.57,
    y1: 8.28,
    x2: 8.57,
    y2: 8.28
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(0 41.97) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(.27 25.78) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(.54 9.7) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(0 90.71) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(37.59 129.87) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(0 106.76) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(20.75 129.87) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(69.35 129.87) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(52.51 129.87) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(102.03 129.87) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(85.19 129.87) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(116.95 129.87) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(.8 123.11) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(.27 74.52) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(.54 58.44) scale(1.08 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosKoordinat1);
export default __webpack_public_path__ + "static/media/bos-koordinat-1.688c82afe39cc531fb672d403b70bed9.svg";
export { ForwardRef as ReactComponent };